import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { SiteTheme } from './components/SiteTheme';
import { GlobalStyles } from './styles/GlobalStyles';
import './styles/phase1.css';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';

import PortfolioPage, { ProjectDetailPage } from './components/PortfolioHome';
import AboutPage from './pages/AboutPage';
// Must stay last so it overrides styles imported by the page components.
import './styles/polish.css';

function App() {
  return (
    <SiteTheme><MotionConfig reducedMotion="user">
      <GlobalStyles />
      <div className="relative min-h-screen">
        <a className="skip-link" href="#main-content">Skip to content</a>
        {/* Navigation and content with higher z-index */}
        <div className="relative z-10">
          <Navigation />
          <main id="main-content" tabIndex={-1} className="space-y-10 pb-20">

              <Routes>
                <Route path="/" element={<PortfolioPage />} />
                <Route path="/home" element={<Navigate to="/" replace/>} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/experience" element={<PortfolioPage page="experience"/>} />
                <Route path="/projects" element={<PortfolioPage page="projects"/>} />
                <Route path="/projects/:projectId" element={<ProjectDetailPage/>} />
                <Route path="/skills" element={<PortfolioPage page="skills"/>} />
                <Route path="/education" element={<PortfolioPage page="education"/>} />
                <Route path="/contact" element={<PortfolioPage page="contact"/>} />
                <Route path="/education-skills" element={<Navigate to="/education" replace/>} />
                <Route path="*" element={<Navigate to="/" replace/>} />
              </Routes>

          </main>
          <Footer />
        </div>
      </div>
    </MotionConfig></SiteTheme>
  );
}

export default App;
